export const INITIALISE_STORE_DEVICE_TOKEN = 'INITIALISE_STORE_DEVICE_TOKEN';

export const STORE_DEVICE_TOKEN = 'STORE_DEVICE_TOKEN';
